module.exports = __webpack_public_path__ + "static/intro-1044768344.ff2159f0.jpg";